var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2859 1.08009H4.84888C3.95068 1.08009 3.21998 1.81299 3.21998 2.71389V3.21974H2.70873C1.81053 3.21974 1.07983 3.95264 1.07983 4.85404V13.2862C1.07983 14.1871 1.81053 14.92 2.70873 14.92H11.146C12.0471 14.92 12.78 14.1871 12.78 13.2862V12.7803H13.2859C14.187 12.7803 14.9202 12.0474 14.9202 11.146V2.71384C14.9201 1.81299 14.187 1.08009 13.2859 1.08009ZM11.78 13.2861C11.78 13.6357 11.4956 13.9199 11.146 13.9199H2.70873C2.36203 13.9199 2.07983 13.6357 2.07983 13.2861V4.85399C2.07983 4.50439 2.36208 4.21969 2.70873 4.21969H3.71998H11.146C11.4956 4.21969 11.78 4.50434 11.78 4.85399V12.2802V13.2861ZM13.9201 11.146C13.9201 11.4956 13.6357 11.7803 13.2858 11.7803H12.78V4.85399C12.78 3.95264 12.0471 3.21969 11.1459 3.21969H4.21993V2.71384C4.21993 2.36424 4.50218 2.08004 4.84883 2.08004H13.2858C13.6357 2.08004 13.9201 2.36424 13.9201 2.71384V11.146Z",
    fill: "#0087CE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.2a320c231341b0651082459b047997d8.svg";
export { ForwardRef as ReactComponent };